import TextBox from "devextreme/ui/text_box";
TextBox.defaultOptions({
    options: {
        onFocusIn: (e) => {
            if (e.event.target.select) e.event.target.select();
        },
    }
});